import { getBaseQuery, getBaseUrl } from '../api.util.ts'
import { createApi } from '@reduxjs/toolkit/query/react'
import {
  GetBookDetailsRequest,
  GetBookDetailsResponse,
} from './book-api.def.ts'

const interfaceName = 'book'

export const bookApi = createApi({
  reducerPath: 'bookApi',
  baseQuery: getBaseQuery(getBaseUrl(interfaceName)),
  tagTypes: ['book'],
  endpoints: (build) => ({
    getBookDetails: build.query<GetBookDetailsResponse, GetBookDetailsRequest>({
      query: (params) => ({
        url: `/${params.id}`,
        method: 'GET',
        params: params,
      }),
    }),
  }),
})

export const { useGetBookDetailsQuery, useLazyGetBookDetailsQuery } = bookApi
